import _ from "lodash";
import { Dialog } from "material-ui";
import { Component, default as React } from "react";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/customapps";
import ActionButton from "../components/common/ActionButton";
import DocumentView from "../components/common/DocumentView";
import InstructionPhoto from "../components/common/InstructionPhoto";
import InstructionVideo from "../components/common/InstructionVideo";
import Title from "../components/common/Title";
import WistiaAsyncVideo from "../components/common/WistiaAsyncVideo";
import YouTubeVideo from "../components/common/YouTubeVideo";
import { Mixpanel } from "../mixpanel";
import IconDuration from "../resources/icons/icon_duration.png";
import IconFrequency from "../resources/icons/icon_frequency.png";
import IconReps from "../resources/icons/icon_reps.png";
import IconSets from "../resources/icons/icon_sets.png";

import IconWeight from "../resources/icons/icon_weight.png";
import IconRest from "../resources/icons/icon_rest.png";
import IconHold from "../resources/icons/icon_hold.png";
import IconTempo from "../resources/icons/icon_tempo.png";

import trophyWithRibbon from "../resources/icons/trophy_with_ribbon.png";
import "../resources/styles/BigCalendar.css";
import events from "../services/events";
import userActivityService from "../services/userActivity";
import colors, { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";
import AppFrame from "./AppFrame";

const styles = {
  instructionContainer: {
    display: "flex",
    flexDirection: "column",
    maxWidth: 1000,
  },
  title: {
    fontFamily: "Poppins",
    fontSize: 20,
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "30px",
    letterSpacing: "0em",
    textAlign: "left",
    color: colorsV2.primary,
  },
  mediaContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    flexWrap: "wrap",
  },
  imageSize: {
    height: 350,
    width: 400,
    backgroundPosition: "unset",
  },
  videoSize: {
    height: 350,
    width: 400,
  },
  description: {
    fontFamily: "Poppins-Regular",
    fontSize: 18,
    color: colorsV2.silverChalice,
  },
  attributesContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    marginTop: 20,
    marginBottom: 20,
  },
  attributeContainer: {
    width: 100,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    padding: 0,
    margin: 0,
  },
  attributeIcon: {
    height: 25,
    width: 25,
    padding: 0,
    margin: 0,
  },
  attributeName: {
    fontSize: 12,
    padding: 0,
    margin: 0,
    color: "#476F83",
  },
  attributeValue: {
    fontSize: 12,
    padding: 0,
    margin: 0,
  },
  label: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: colors.primary,
    marginTop: 15,
  },
  pointsCollectedTrophy: {
    width: 47,
    height: 47,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
  pointsEarnedLable: {
    color: colors.text,
    textAlign: "right",
    fontSize: 20,
    fontWeight: 900,
  },
  pointsEarnedImageContainer: {
    borderStyle: "solid",
    borderColor: colors.steelBlue,
    backgroundColor: "white",
    borderWidth: 2,
    padding: 0,
    borderRadius: 40,
    width: 47,
    height: 47,
    margin: 2,
    marginTop: 5,
  },
  modalHeader: {
    background: colors.primary,
    textAlign: "center",
    color: colors.white,
    fontWeight: "900",
  },
};

class PatientInstructionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: props.match.params.userId,
      appId: props.match.params.appId,
      instruction: props.location.state.instruction
        ? props.location.state.instruction
        : {},
      activityDate: new Date(),
      customAppId: undefined,
      isPointsEarnedDialogOpen: false,
      width: 0,
      height: 0,
    };
  }

  componentWillMount() {
    this.props.fetchCustomApp(this.state.appId, this.state.userId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.userId &&
      this.state.appId &&
      _.isEmpty(this.state.customApp) &&
      !_.isEmpty(nextProps.customapps.customApps[this.state.appId])
    ) {
      const customApps = nextProps.customapps.customApps[this.state.appId];
      this.setState({
        customApp: customApps[this.state.userId],
        customAppId: customApps[this.state.userId].customAppId,
      });
    }
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  renderPhysioVideo = (iframeHtml) => {
    const url = iframeHtml.substring(
      iframeHtml.indexOf("src=") + 5,
      iframeHtml.indexOf("width") - 2
    );
    return (
      <iframe
        title="Physio PT Video"
        src={url}
        style={{ width: 500, height: 500 }}
        frameborder="0"
        allowfullscreen
      ></iframe>
    );
  };

  renderInstructionMedia() {
    const { videoUrl } = this.state.instruction;

    const base =
      "https://user-image-storage.s3.amazonaws.com/compressed/video/";
    const isValid =
      !_.isEmpty(videoUrl) &&
      (!videoUrl.startsWith(base) ||
        videoUrl.substring(base.length).split("?")[0].trim() !== "");
    return (
      <div style={styles.mediaContainer}>
        {this.state.instruction.imageUrl && (
          <InstructionPhoto
            url={this.state.instruction.imageUrl}
            style={styles.imageSize}
          />
        )}
        {this.state.instruction.videoUrl && isValid && (
          <InstructionVideo
            url={this.state.instruction.videoUrl}
            userId={this.state.userId}
            instructionId={this.state.instruction.categoryId}
            style={styles.videoSize}
            customApp={this.state.customApp}
            instructionName={this.state.instruction.categoryName}
          />
        )}

        {this.state.instruction.physioVideo &&
          this.renderPhysioVideo(this.state.instruction.physioVideo)}

        {this.state.instruction.youtubeVideo && (
          <YouTubeVideo
            url={this.state.instruction.youtubeVideo.url}
            embedId={this.state.instruction.youtubeVideo.id}
            instructionId={this.state.instruction.categoryId}
            userId={this.state.userId}
          />
        )}
        {this.state.instruction.wistiaVideo &&
          this.state.instruction.wistiaVideo.url !== "" && (
            <WistiaAsyncVideo
              wistiaVideo={this.state.instruction.wistiaVideo}
            />
          )}
        {this.state.instruction.physioImage && (
          <InstructionPhoto
            url={this.state.instruction.physioImage}
            style={{ maxHeight: 500, maxWidth: 500 }}
          />
        )}
      </div>
    );
  }

  renderInstructionAttributes() {
    return (
      <div style={styles.attributesContainer}>
        {this.state.instruction.numRepetitions && (
          <div style={styles.attributeContainer}>
            <img src={IconReps} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Reps</p>
            <p style={styles.attributeValue}>
              {this.state.instruction.numRepetitions}
            </p>
          </div>
        )}
        {this.state.instruction.numSets && (
          <div style={styles.attributeContainer}>
            <img src={IconSets} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Sets</p>
            <p style={styles.attributeValue}>
              {this.state.instruction.numSets}
            </p>
          </div>
        )}
        {this.state.instruction.duration && (
          <div style={styles.attributeContainer}>
            <img src={IconDuration} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Duration</p>
            <p style={styles.attributeValue}>
              {this.state.instruction.duration}
            </p>
          </div>
        )}
        {this.state.instruction.frequency && (
          <div style={styles.attributeContainer}>
            <img src={IconFrequency} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Frequency</p>
            <p style={styles.attributeValue}>
              {this.state.instruction.frequency}
            </p>
          </div>
        )}
        {this.state.instruction.rest && (
          <div style={styles.attributeContainer}>
            <img src={IconRest} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Rest</p>
            <p style={styles.attributeValue}>{this.state.instruction.rest}</p>
          </div>
        )}
        {this.state.instruction.hold && (
          <div style={styles.attributeContainer}>
            <img src={IconHold} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Hold</p>
            <p style={styles.attributeValue}>{this.state.instruction.hold}</p>
          </div>
        )}
        {this.state.instruction.tempo && (
          <div style={styles.attributeContainer}>
            <img src={IconTempo} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Tempo</p>
            <p style={styles.attributeValue}>{this.state.instruction.tempo}</p>
          </div>
        )}
        {this.state.instruction.weight && (
          <div style={styles.attributeContainer}>
            <img src={IconWeight} style={styles.attributeIcon} />
            <p style={styles.attributeName}>Weight</p>
            <p style={styles.attributeValue}>{this.state.instruction.weight}</p>
          </div>
        )}
      </div>
    );
  }

  renderInstructionDesc() {
    return (
      <div>
        <label style={styles.label}>Description :</label>
        <div
          style={{ marginBottom: 15 }}
          dangerouslySetInnerHTML={{
            __html: this.state.instruction.categoryDescWithFormat
              ? this.state.instruction.categoryDescWithFormat
              : this.state.instruction.categoryDesc,
          }}
        />
      </div>
    );
  }

  renderPointsEarnedDialog() {
    return (
      <Dialog
        open={this.state.isPointsEarnedDialogOpen}
        modal={false}
        onRequestClose={() => {
          this.setState({ isPointsEarnedDialogOpen: false });
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          <div style={styles.pointsEarnedImageContainer}>
            <img src={trophyWithRibbon} style={styles.pointsCollectedTrophy} />
          </div>
          <p
            style={{ ...styles.pointsEarnedLable, fontSize: 17, marginLeft: 8 }}
          >
            You've earned{" "}
            <span style={{ color: colors.orange, fontSize: 20 }}>
              +{this.state.ptsEarned}
            </span>{" "}
            points!
          </p>
        </div>
      </Dialog>
    );
  }

  submitUserActitivity = () => {
    const activities = [
      {
        activityId: this.state.instruction.categoryId,
        activityName: this.state.instruction.categoryName,
      },
    ];

    userActivityService()
      .addUserActivity(
        this.state.userId,
        this.state.customAppId,
        this.state.activityDate.getTime(),
        activities
      )
      .then((resp) => {
        this.props.fetchCustomApp(this.state.appId, this.state.userId);

        let updateApp = this.state.customApp;
        updateApp.points = updateApp.points + activities.length * 100;

        this.setState({
          isPointsEarnedDialogOpen: true,
          ptsEarned: activities.length * 100,
          customApp: updateApp,
        });
        setTimeout(() => {
          this.setState({ isPointsEarnedDialogOpen: false, ptsEarned: 0 });
        }, 3000);
      });

    Mixpanel.track("Log Activity", {
      "Patient ID": this.state.userId,
      "Channel ID": this.state.customAppId,
      "Acivity Date": this.state.activityDate.getTime(),
      "Instruction ID": activities,
      Platform: "Web",
    });

    events().trackUserEvent(
      "Log Activity",
      this.state.customApp.appInfo.appId,
      this.state.customAppId,
      this.state.instruction.categoryId,
      null,
      this.props.user.userId,
      null,
      "portal",
      this.state.customApp.appName,
      this.state.instruction.categoryName,
      null
    );
  };

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame auth={this.props.auth} targetDevice={targetDevice}>
        <div style={layout.common.page}>
          <Title
            text2={"Instruction View"}
            goBack={() => this.props.history.goBack()}
          />
          <div style={layout.common.mainContainer}>
            <div style={{ display: "flex", flexDirection: "row-reverse" }}>
              <ActionButton
                label="I did it"
                disabled={
                  !this.state.customAppId || this.state.isPointsEarnedDialogOpen
                }
                onClick={() => this.submitUserActitivity()}
              />
            </div>
            <div style={styles.instructionContainer}>
              <p style={styles.title}>{this.state.instruction.categoryName}</p>
              {this.renderInstructionMedia()}
              {this.renderInstructionAttributes()}
              {this.renderInstructionDesc()}
              <DocumentView documents={this.state.instruction.documents} />
            </div>
          </div>
          {this.renderPointsEarnedDialog()}
        </div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, customapps }) {
  return {
    user,
    customapps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientInstructionView);



// WEBPACK FOOTER //
// ./src/layout/PatientInstructionView.js